import React      from 'react';
import CSSModules from 'react-css-modules';

import Overlay          from '../Overlay';
import YesNoOptionPanel from '../YesNoOptionPanel';

import bookings from '../../services/bookings';

import style from './style.scss';

class RemoveTransactionDelegateOverlay extends React.Component {

    constructor() {

        super();

        this.state = {
            isDeleting: false
        }
    }

    _deleteDelegate(delegateId) {

        this.setState({ isDeleting: true });

        const deleteSuccess = () => {

            this.setState({ isDeleting: false });
            this.props.onRemoveSuccess();
        };

        bookings.deleteDelegate(delegateId)
            .then(deleteSuccess.bind(this));
    }

    render() {

        if (!this.props.delegate)
            return null;

        return (
            <Overlay isOpen={ this.props.delegate }
                     closeOverlay={ this.props.closeOverlay }
                     title="Delete Delegate"
                     size="small">

                <p>
                    Are you sure you want to delete the delegate <strong>{ this.props.delegate.first_name } { this.props.delegate.last_name }</strong> from this transaction?
                </p>

                <p>
                    Please note, this will re-calculate the amounts for this transaction.
                </p>

                <YesNoOptionPanel yes={ this._deleteDelegate.bind(this, this.props.delegate.id) }
                                  no={ this.props.closeOverlay }
                                  isLoading={ this.state.isDeleting } />

            </Overlay>
        )
    }
}

export default CSSModules(RemoveTransactionDelegateOverlay, style);


// WEBPACK FOOTER //
// ./components/RemoveTransactionDelegateOverlay/index.js